import type { OrderCancellationPolicyActionType } from '@/backend/market'

export class OrderCancellationPolicyHistoryEntity {
  id?: string
  branchId?: number
  branchName?: string | null
  policyId?: number
  policyName?: string | null
  orderId?: string
  cancelOrderReasonId?: number
  cancelOrderReasonTitle?: string | null
  basePolicyMatched?: boolean
  escalationMatched?: boolean
  enforcedActionType?: OrderCancellationPolicyActionType
  enforcedCloseDurationHours?: number | null
  enforcedExpiresAt?: string | null
  countAtEvaluation?: number
  escalationCountAtEvaluation?: number | null
  triggeredAt?: string
  metadataJson?: string | null
}
